<template>
  <div id="app">
    <div class="container">
      <identifier-wrapper>
        <outcome-wrapper>
          <router-view />
        </outcome-wrapper>
      </identifier-wrapper>
    </div>
  </div>
</template>

<script>
  import identifier_wrapper from './components/wrappers/identifier'
  import outcome_wrapper from './components/wrappers/outcome'

  export default {
    components: {
      'identifier-wrapper': identifier_wrapper,
      'outcome-wrapper': outcome_wrapper,
    },
    created() {
      this.set_ctrl_prize(this);
      this.set_ctrl_game(this);
    }
  }
</script>